import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import { Suspense } from "react";
import { pages } from "@/lib/pages";

const { Dashboard, Policies, Customers, Prospects, Groups, Admin, Reports, Archive, DataEntry, Proforma, Ledger, Settings, WhatsApp, Hakedis, Profile, Landing, Legal, Taslak, WalletPublic, ForgotPassword, ResetPassword } = pages;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/tanitim" element={<Landing />} />
            <Route path="/gizlilik" element={<Legal />} />
            <Route path="/kullanim-sozlesmesi" element={<Legal />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/cuzdan/:token" element={<WalletPublic />} />
            <Route path="/taslak" element={<ProtectedRoute><Taslak /></ProtectedRoute>} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/policies" element={<Policies />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/data-entry" element={<DataEntry />} />
              <Route path="/proforma" element={<Proforma />} />
              <Route path="/prospects" element={<Prospects />} />
              <Route path="/gruplar" element={<Groups />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/archive" element={<Archive />} />
              <Route path="/muhasebe" element={<Ledger />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/whatsapp" element={<WhatsApp />} />
              <Route path="/hakedis" element={<Hakedis />} />
              <Route path="/profile" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
